import React from "react";
import systurn from "../../../../assets/systurn.png";
import userturn from "../../../../assets/userturn.png";
import exitchaticon from "../../../../assets/exitchat.png";

const ProfileSidebar = ({ onExitChat, systemThinking, userTurn }) => {
  let currentMascot;
  if (userTurn) {
    currentMascot = systurn;
  } else if (systemThinking) {
    currentMascot = userturn;
  } else {
    currentMascot = userturn;
  }

  return (
    <div className="w-full max-w-[322px] min-w-[280px] h-[805px] bg-white rounded-[20px] shadow-sm flex flex-col items-center py-6 px-6 overflow-hidden">
      <div className="relative mb-4">
        <div
          className="absolute"
          style={{
            width: "180px",
            height: "180px",
            top: "85px",
            left: "10px",
            borderRadius: "50%",
            background: "#54B0AF",
            opacity: 1,
            zIndex: 1,
          }}
        ></div>

        <div
          className="relative"
          style={{ width: "195px", height: "255px" }}
        >
          <img
            src={currentMascot}
            alt={systemThinking ? "System Thinking" : "User Thinking"}
            className="elliptical-crop"
            style={{
              width: "195px",
              height: "255px",
              top: "10px",
              left: "5px",
              position: "relative",
              objectFit: "contain",
              opacity: 1,
              zIndex: 10,
            }}
          />
        </div>
      </div>

      <h2 className="text-lg font-semibold text-[#323232] font-gotham mb-1">SiYu</h2>

      <p className="text-[12px] font-medium text-gray-400 uppercase tracking-wider mb-2 font-gotham">
        ANALYSIS COMPANION
      </p>

      <p className="text-[14px] leading-[150%] text-center text-[#323232] mb-32 px-4 font-gotham">
        Hello, I'm SiYu!
        <br />
        I'm here to help you discover your strengths and navigate your career journey
        with confidence. I analyze your reflections and provide insights to
        help you grow.
      </p>

      <button
        onClick={onExitChat}
        className="w-[192px] h-[56px] flex items-center justify-center gap-2 bg-[#D9D9D9] hover:bg-[#C4C4C4] text-[#000000] font-medium rounded-[11px] transition-all duration-200 mt-4 font-gotham uppercase"
      >
        <span className="text-[14px] leading-[135%]">EXIT CHAT</span>
        <img
          src={exitchaticon}
          alt="Exit Chat Icon"
          style={{
            width: "16px",
            height: "16px",
            objectFit: "contain",
          }}
        />
      </button>
    </div>
  );
};

export default ProfileSidebar;



// import React from "react";
// import systurn from "../../../../assets/systurn.png";
// import userturn from "../../../../assets/userturn.png";
// import exitchaticon from "../../../../assets/exitchat.png";

// const ProfileSidebar = ({ onExitChat, systemThinking, userTurn }) => {
//   let currentMascot;
//   if (userTurn) {
//     currentMascot = systurn;
//   } else if (systemThinking) {
//     currentMascot = userturn;
//   } else {
//     currentMascot = userturn;
//   }

//   return (
//     <div className="w-full max-w-[322px] min-w-[280px] max-h-[805px] bg-white rounded-[20px] shadow-sm flex flex-col items-center py-8 px-6">
//       <div className="relative mb-6">
//         <div
//           className="absolute"
//           style={{
//             width: "220.765625px",
//             height: "220.765625px",
//             top: "105px",
//             left: "12px",
//             borderRadius: "50%",
//             background: "#54B0AF",
//             opacity: 1,
//             zIndex: 1,
//           }}
//         ></div>

//         <div
//           className="relative"
//           style={{ width: "240.46875px", height: "315.234375px" }}
//         >
//           <img
//             src={currentMascot}
//             alt={systemThinking ? "System Thinking" : "User Thinking"}
//             className="elliptical-crop"
//             style={{
//               width: "240.46875px",
//               height: "315.234375px",
//               top: "12px",
//               left: "5px",
//               position: "relative",
//               objectFit: "contain",
//               opacity: 1,
//               zIndex: 10,
//             }}
//           />
//         </div>
//       </div>

//       <h2 className="text-xl font-semibold text-[#323232] font-gotham">SiYu</h2>

//       <p className="text-[14px] font-medium text-gray-400 uppercase tracking-wider mb-3 font-gotham">
//         ANALYSIS COMPANION
//       </p>

//       <p className="text-[16px] leading-[165%] text-center text-[#323232] mb-auto px-4 font-gotham">
//         Hello, I'm SiYu!
//         <br />
//         I'm here to help you discover your strengths and navigate your career journey
//         with confidence. I analyze your reflections and provide insights to
//         help you grow.
//       </p>

//       <button
//         onClick={onExitChat}
//         className="w-[192px] h-[56px] flex items-center justify-center gap-2 bg-[#D9D9D9] hover:bg-[#C4C4C4] text-[#000000] font-medium rounded-[11px] transition-all duration-200 mt-6 font-gotham uppercase"
//       >
//         <span className="text-[15.69px] leading-[135%]">EXIT CHAT</span>
//         <img
//           src={exitchaticon}
//           alt="Exit Chat Icon"
//           style={{
//             width: "17.4360408782959px",
//             height: "17.4360408782959px",
//             objectFit: "contain",
//           }}
//         />
//       </button>
//     </div>
//   );
// };

// export default ProfileSidebar;
